export default "__VITE_ASSET__Bl1js5Sq__"